import { render } from "./SubmitOTP.vue?vue&type=template&id=bee7a1f8&scoped=true"
import script from "./SubmitOTP.vue?vue&type=script&lang=js"
export * from "./SubmitOTP.vue?vue&type=script&lang=js"

import "./SubmitOTP.vue?vue&type=style&index=0&id=bee7a1f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee7a1f8"]])

export default __exports__